import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getUserInfo } from '../../redux/selectors'
import { fetchContacts, updateContacts } from '../../redux/actions'
import ManageUsersComponent from './ManageUsersComponent'
import { isEmpty } from 'lodash'
import { requesterEmailAddress } from '../../libs/utils'

class ManageUsersContainer extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      contacts: null
    }
  }

  componentDidMount () {
    document.title = 'User Profile - Manage Users'
    const emailAddress = requesterEmailAddress(this.props)
    this.props.fetchContacts(emailAddress)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (isEmpty(nextProps) || isEmpty(nextProps.contacts) || !Array.isArray(nextProps.contacts)) return {contacts: null}
    const contactHash = nextProps.contacts.reduce((contactObj, contact) => {
      if (isEmpty(contactObj[contact.company])) contactObj[contact.company] = []
      return {
        ...contactObj,
        [contact.company]: contact.pending
          ? contactObj[contact.company]
          : [
            ...contactObj[contact.company],
            contact
          ],
        pending: contact.pending
          ? [
            ...contactObj.pending,
            contact
          ]
          : contactObj.pending
      }
    }, {pending: []})
    return {
      contacts: contactHash
    }
  }

  render () {
    const { contacts } = this.state
    const { history, emailAddress } = this.props
    return (
      <ManageUsersComponent contacts={contacts} history={history} emailAddress={emailAddress} />
    )
  }
}

ManageUsersContainer.propTypes = {}

const mapStateToProps = state => ({
  emailAddress: getUserInfo(state).emailAddress,
  contacts: getUserInfo(state).contacts
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    fetchContacts,
    updateContacts // 2018-11-02: doesn't look to be used
  }, dispatch)
)

const ManageUsersConnect = connect(mapStateToProps, mapDispatchToProps)(ManageUsersContainer)

export default ManageUsersConnect
